import { CXF } from '@goodgamestudios/cxf-runtime'
import {
  BannersConfig,
  BannersConfigWithDefault,
  BigFarm as BF_CONFIG,
  DEFAULT_CONFIG,
  Empire as EM_CONFIG,
} from './game-configs'
import log from '../utils/logger'
import { gameAliasToIdMap } from '../constants'

// the gameId is a string in login events thus the key in mapping is the string
const GAMES_CONFIGS = new Map<string, BannersConfig>([
  [`${gameAliasToIdMap.BIGFARM}`, BF_CONFIG],
  [`${gameAliasToIdMap.EMPIRE}`, EM_CONFIG],
])

export const getConfig = ({ gameId }: { gameId: CXF['gameId'] }): BannersConfigWithDefault => {
  const gameConfig = GAMES_CONFIGS.get(gameId)

  if (!gameConfig) {
    log(`Game '${gameId}' is not supported`)
    throw new Error(`Game '${gameId}' is not supported`)
  }

  return {
    ...DEFAULT_CONFIG,
    ...gameConfig,
  }
}

export { GAMES_CONFIGS }
